import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { LinkContainer } from "react-router-bootstrap";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
// My Components
import { AppContext } from './lib/contextLib';
import { user, setUserState } from './lib/authLib';
import config from './config';
import SideBar from './containers/SideBar';
import CustomFooter from './containers/CustomFooter';
import Routes from './Routes';
import logo from './imgs/logo.jpg';
import "./App.scss";

function App() {
  const history = useHistory();
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    onLoad();
  }, []);
  
  async function onLoad() {
    try {
      await Auth.currentSession();
      // Luke auth role stuff
      const authenticatedUser = await Auth.currentAuthenticatedUser();
      console.log("> authenticatedUser\n", authenticatedUser);
      await setUserState('', authenticatedUser.attributes.email);
      // ! Luke auth role stuff
      userHasAuthenticated(true);
    }
    catch(e) {
      console.error('Error, App.js line 40');

      if (e === 'No current user') {
        console.error('No current user, App.js line 40');
      } else {
        console.error('Other error!');
      }

      console.error(e);
    }
  
    setIsAuthenticating(false);
  }

  async function handleLogout() {
    await Auth.signOut();
  
    userHasAuthenticated(false);

    history.push("/login");
  }

  const isAdminAndLoggedIn = isAuthenticated && user[0].role === 'admin';

  return (
    !isAuthenticating && (
      <div className="App container py-3">
        {/* Navbar */}
        <Navbar fixed="top" collapseOnSelect bg="dark" expand="md" className="mb-3">
          <LinkContainer to="/">
            <Navbar.Brand className="font-weight-bold text-muted">
              <img
                src={logo}
                alt="Century"
                className="century-logo"
              />
              Century Ballroom
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle className="navbar-dark" />
          <Navbar.Collapse className="justify-content-end">
            <Nav activeKey={window.location.pathname}>
              {isAuthenticated ? (
                <>
                  <LinkContainer className="top-right-links" to="/settings">
                    <Nav.Link>Settings</Nav.Link>
                  </LinkContainer>
                  <Nav.Link className="top-right-links" onClick={handleLogout}>
                    Logout
                  </Nav.Link>
                </>
              ) : (
                <>
                  <LinkContainer className="top-right-links" to="/signup">
                    <Nav.Link>Signup</Nav.Link>
                  </LinkContainer>
                  <LinkContainer className="top-right-links" to="/login">
                    <Nav.Link>Login</Nav.Link>
                  </LinkContainer>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
          <div className={`routes-container ${isAdminAndLoggedIn ? 'accomodate-sidebar' : ''}`}>
            <Routes />
          </div>
        </AppContext.Provider>
        { isAdminAndLoggedIn && <SideBar /> }
        <CustomFooter />
      </div>
    )
  );
}

export default App;
